import { useMemo, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';
import { useConfigService } from '@thd-nucleus/experience-context';
import { getPrice } from '../api/pricing';
import {
  usePromoStore, useProductDataStore
} from '../store';
import { useDesignStore } from '../store/design/context';
import { getSVOCID, getCustomerType, getUserLoggedIn } from '../utils/query-utils';

const fulfillmentProductsDiff = (prev, next) => {
  const prevSkusAndQuantity = _map(prev, (acc) => `${acc?.itemId}-${acc?.quantity}`);
  const nextSkusAndQuantity = _map(next, (acc) => `${acc?.itemId}-${acc?.quantity}`);
  return prevSkusAndQuantity.join() !== nextSkusAndQuantity.join();
};

export default () => {
  const host = useConfigService('global-custom-commerce:host');
  const products = useDesignStore((state) => state.design.products);
  const cart = useDesignStore((state) => state.design.cart);
  const fulfillmentProducts = usePromoStore((state) => state.fulfillmentProducts);
  const updateDiscounts = usePromoStore((state) => state.updateDiscounts);
  const productData = useProductDataStore((state) => state.productData);
  const [compare, setCompare] = useState([]);
  const custType = getCustomerType();
  const svocId = getSVOCID();
  const isAuthenticated = getUserLoggedIn();

  // price adjustment requires storeSkuNumber or omsThdSku to give correct pricing
  // when multiple discounts are at play (itemId is final fallback)

  useMemo(() => {
    if (!_isEmpty(fulfillmentProducts)) {
      const itemData = fulfillmentProducts.map((promoMapData, index) => {
        return {
          itemId: promoMapData.storeSkuNumber || promoMapData.omsThdSku || promoMapData.itemId,
          refId: index,
          qty: promoMapData.quantity,
          price: promoMapData.unitPrice,
          hasDisc: false
        };
      });
      const filteredData = itemData.filter((combo) => {
        const validItemId = combo?.itemId !== undefined && combo?.itemId !== null && combo?.itemId !== '0';

        return validItemId ? combo.itemId : null;
      });
      const designData = {
        cartRequest: {
          custId: svocId,
          custType,
          orderId: '000000',
          location: '8119',
          channel: 'INET',
          items: filteredData,
          svocId,
          isAuthenticated,
        }
      };
      const diff = fulfillmentProductsDiff(compare, fulfillmentProducts);

      if (diff && designData?.cartRequest?.items?.length > 0) {
        Promise.resolve(getPrice(host, designData))
          .then((res) => {
            updateDiscounts(res?.data);
          });
      }
      return setCompare(fulfillmentProducts);
    }
    return setCompare([]);
  }, [productData, products, cart]);
};
